module.exports = __webpack_public_path__ + "static/img/ongjin-pt.ce8566a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/ongjin-pt.jpg
// module id = 1MVg
// module chunks = 0